import "primereact/resources/themes/viva-light/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import React, { createContext } from 'react';
import Home from "./components/Home";
import About from "./components/About";
import Program from "./components/Program";
import './App.scss';
import Contact from "./components/Contact";
import Reports from "./components/Reports";
import ScrollToTop from "./components/ScrollToTop";
import WhatsAppButton from "./components/WhatsAppButton";

export const ThemeContext = createContext('light');

const App = () => {
  return (
    <ThemeContext.Provider value="dark">
      <Router> 
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="/about/*" element={<About />} />
            <Route path="/program" element={<Program />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/reports" element={<Reports />} />
          </Route>
        </Routes>
        <WhatsAppButton />
      </Router>
    </ThemeContext.Provider>
  );
};

export default App;
